import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { IMajorTech } from "../../models/MajorTech";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { useForm } from "react-hook-form";
import { JVInput } from "../../shared/JVInput";
import { IRolesDropdown } from "../../models/IDropdown";
import { IRoleMast } from "../../models/RoleMast";
import { JVDropdown } from "../../shared/JVDropdown";
import { format } from "date-fns";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { resourceLimits } from "worker_threads";

interface IProps {
    singledata: any,
    open: boolean,
    hideHistory: () => void,
    toast: any,
    permissions?: IPermissionProps
}
interface Roles {
    role_ID: number,
    parent_ID: number
}

const EmptyAddJob: IRoleMast = {
    role_Name: "",
    role_Description: ""
}

export const AddSubRoleForm = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [roles, setRoles] = useState<Array<IRolesDropdown>>();
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedRoles, setSelectedRoles] = useState<Array<IRolesDropdown>>();


    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<any>({
        defaultValues: props.singledata,
        shouldFocusError: false
    });

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Role_Mast/getSubRole", "GET", null, `id=${props.singledata.role_ID}`, props.toast);
        if (response) {
            const data: Array<IMajorTech> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }


    const saveToDB = async (body: IRoleMast) => {
        setLoading(true);
        body = { role_Name: body.role_Name, parent_ID: props.singledata.role_ID, role_Description: body.role_Description }
        const response = await Fetch("Role_Mast/AddSubRole", "POST", body, null, props.toast);
        if (response) {
            setLoading(false);
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            loadTableData();
        } else setLoading(false);
        reset(EmptyAddJob);

    }

    const updateParentInDB = async (body: IRoleMast) => {
        setLoading(true);

        const _role_ID: Array<Roles> = [];
        selectedRoles?.forEach(rec => {
            _role_ID.push({ role_ID: rec.role_ID, parent_ID: props.singledata.role_ID });
        });
        let query: null | string = null;
        if (_role_ID.length > 0) query = "roles=" + JSON.stringify(_role_ID);


        // const updatePayload = {
        //     role_ID: body.role_ID, // existing role ID
        //     parent_ID: props.singledata.role_ID // new parent ID to assign
        // };
        const response = await Fetch("Role_Mast/AddOrUpdateSubRole", "POST", null, query, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Parent Updated Successfully", life: 3000 });
            loadTableData();
        }
        setLoading(false);
        setSelectedRoles([])
        loadRoles();
    };



    const loadRoles = async () => {
        const response = await Fetch("Dropdown/rolessub", "GET", null, null, null);
        if (response) {
            const data: Array<IRolesDropdown> = await response.json();
            const _data: Array<IRolesDropdown> = [];
            data.forEach(d => {
                _data.push({ role_ID: d.role_ID, role_Name: d.role_Name });
            })
            setRoles(_data);
            // setSelectedRoles(_data);

        }
    }

    const onHide = () => {
        props.hideHistory();
        setSelectedRoles([])


    }

    const onSubmit = (data: any) => {
        saveToDB(data);
    }

    useEffect(() => {
        loadRoles();
    }, []);

    useEffect(() => {
        if (props.open) loadTableData();
    }, [props.open]);

    const removeMember = async (body: IRoleMast) => {
        setLoading(true);
        const updatePayload = {
            role_ID: body.role_ID, // existing role ID
            parent_ID: 0 // new parent ID to assign
        };
        const response = await Fetch("Role_Mast/RemoveSubRoless", "POST", updatePayload, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Parent Updated Successfully", life: 3000 });
            loadTableData();
        }
        setLoading(false);
    };

    const deleteMember = async (body: IRoleMast) => {
        setLoading(true);
        const updatePayload = {
            role_ID: body.role_ID, // existing role ID
            parent_ID: 0 // new parent ID to assign
        };
        const response = await Fetch("Role_Mast/AddOrUpdateSubRole", "DELETE", updatePayload, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Parent Updated Successfully", life: 3000 });
            loadTableData();
        }
        setLoading(false);
    };

    const MoveRemove = (rowData: IRoleMast) => {
        return (<div className="w-full flex justify-content-evenly">

            <Button label="Remove" className="w-6rem" onClick={() => removeMember(rowData)} tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} ></Button>
            {/* {<Button label="Delete" className="w-6rem" onClick={() => deleteMember(rowData)} tooltipOptions={{ position: 'bottom', mouseTrack: true, mouseTrackTop: 15 }} ></Button>} */}

        </div>);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Manage Sub Roles" modal className="p-fluid" onHide={onHide} >
            {/* ADD NEW SUB ROLE SECTION */}
            <div className="p-4 border-1 border-round surface-border mb-4">
                <h5 className="mb-3 text-primary">Add New Sub Role under: {props.singledata.role_Name}</h5>
                <form onSubmit={handleSubmit(onSubmit)} className="formgrid grid align-items-end">
                    {/* Role Name */}
                    <div className="field col-12 md:col-5">
                        <JVInput column={1} label="Role Name" control={control} name="role_Name" />
                    </div>
                    {/* Description */}
                    <div className="field col-12 md:col-5">
                        <JVInput column={1} label="Description" control={control} name="role_Description" />
                    </div>
                    {/* Submit Button */}
                    <div className="field col-12 md:col-2">
                        <label className="hidden md:block">&nbsp;</label>
                        <Button label="Add Sub Role" type="submit" loading={loading} className="w-full md:w-auto" />
                    </div>
                </form>
            </div>
            {/* UPDATE PARENT ROLE SECTION */}
            <div className="p-4 border-1 border-round surface-border mb-4">
                <h5 className="mb-3 text-primary">Update Sub Role for Existing Role</h5>

                <form onSubmit={handleSubmit(updateParentInDB)} className="formgrid grid align-items-end">
                    {/* Dropdown: 9 columns wide on desktop */}
                    <div className="field col-12 md:col-9">
                        <JVMultiselect column={1} label="Select Role" options={roles} optionLabel="role_Name" placeholder="Select Role" value={selectedRoles} onChange={setSelectedRoles} />

                        {/* <JVDropdown required column={1} label="Select Role" control={control} name="role_ID" options={roles} optionLabel="role_Name" optionValue="role_ID" placeholder="Select Existing Role" /> */}
                    </div>
                    {/* Button: 3 columns wide */}
                    <div className="field col-12 md:col-3 mt-2">
                        <label className="hidden md:block">&nbsp;</label> {/* spacing match with label */}
                        <Button label="Update" type="submit" loading={loading} className="w-full md:w-auto mt-2" />
                    </div>
                </form>
            </div>
            {/* SUB ROLE TABLE */}
            <div className="p-4 border-1 border-round surface-border">
                <h5 className="mb-3 text-primary">Sub Roles of {props.singledata.role_Name}</h5>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)' }} size="small" value={tableData.tableData} emptyMessage="No Data found." loading={tableData.loading} className="p-datatable-sm"  >
                    <Column field="role_Name" header="Role Name" />
                    <Column field="user_Name" header="Added By" />
                    <Column field="createdon" header="Created On" body={(rowData) => <p>{rowData.createdon ? format(new Date(rowData.createdon), 'dd/MM/yyyy hh:mm a').toUpperCase().split(" ")[0] : ""}</p>} />
                    <Column field="role_Description" header="Description" />
                    <Column field="" header="" body={MoveRemove} />
                </DataTable>
            </div>
        </Dialog>

    );
}